import React from "react";
import { useTranslation } from 'react-i18next';
import { Link } from "react-router-dom";
import "./PageNotFoundContent.css";

const PageNotFoundContent = () => {
  const { t } = useTranslation();

  return (
    <div className="container">
      <h1 className="errorCode">{t('pageNotFoundTitle')}</h1>
      <h2 className="message">{t('pageNotFoundMessage')}</h2>
      <p className="description">
        {t('pageNotFoundDescription')}
      </p>
      <Link to="/" className="homeButton">
        {t('goBackHome')}
      </Link>
    </div>
  );
};

export default PageNotFoundContent;
